module.exports = __webpack_public_path__ + "img/apple.0862e912.svg";